/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'antd';
import StyledContent from './styled';

export const SuccessStep = ({ handleCancel }) => (
  <StyledContent>
    <h3>Booking successfully allocated on new date!</h3>

    <p>The booking collection date/time has been updated.</p>

    <Button key="submit" type="primary" onClick={handleCancel}>
      Ok, got it
    </Button>
  </StyledContent>
);

export default SuccessStep;
